export default "__VITE_ASSET__CCX7gBlI__"